(function () {
  'use strict';
  if (window.__t305PostHog || (window.Shopify && window.Shopify.designMode)) return;
  window.__t305PostHog = true;
  var configNode = document.getElementById('t305-posthog-config');
  var page;
  try { page = JSON.parse(configNode.textContent); } catch (_) { return; }
  var token = 'phc_ruzMTD9Dxene2jmHwNRRwv7aUZzYi2Ssy35KbaqGnm9N';
  var environment = page.environment;
  var sdk, loading = false, initializing = false, active = false, pageSent = false;
  var leaveSent = false, startedAt = 0, bridgePromise, bridgeValue = '', blockedCheckout = false;
  var originalFetch = window.fetch.bind(window);
  var root = window.Shopify.routes.root || '/';
  var bridgeKey = '__t305_ph_context';
  var cookieKey = 't305_ph_checkout';
  var builderKey = 't305_ph_builder_' + environment, cartSnapshot;
  var routes = ['standerd-dtf-gang-sheet-builder', 'upload-your-premade-dtf-gang-sheet',
    'dtf-transfer-by-size', 'smart-gang-sheet-rolling-canvas-dtf-gang-sheet-builder',
    'upload-your-uv-dtf-gang-sheet', 'standard-uv-dtf-gang-sheet-builder',
    'uv-transfers-by-size', 'free-sample-pack'];

  function status(value) { document.documentElement.setAttribute('data-t305-posthog-status', value); }
  function permitted() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function publicPage() { return !/^\/(?:es\/)?(?:account|checkout|checkouts|challenge|password)(?:\/|$)/.test(window.location.pathname); }
  function cleanURL(value) {
    try { var u = new URL(value, window.location.origin); return /^https?:$/.test(u.protocol) ? u.origin + u.pathname : ''; }
    catch (_) { return ''; }
  }
  function referringDomain(value) {
    try { return new URL(value).hostname; } catch (_) { return '$direct'; }
  }
  function campaign() {
    var result = {}, params = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      var value = params.get(key);
      if (value && /^[a-zA-Z0-9][a-zA-Z0-9 ._-]{0,99}$/.test(value) && !/\d{7}/.test(value)) result[key] = value;
    });
    return result;
  }
  function attribution() {
    var key = 't305_ph_attribution_' + environment;
    var current = campaign(), previous;
    try { previous = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) {}
    var ref = referringDomain(document.referrer);
    if (!previous || Object.keys(current).length || (ref !== '$direct' && ref !== window.location.hostname)) {
      previous = Object.assign({referring_domain: ref, landing_page: cleanURL(window.location.href)}, current);
      try { sessionStorage.setItem(key, JSON.stringify(previous)); } catch (_) {}
    }
    return previous;
  }
  function beforeSend(event) {
    if (!event || !permitted() || !publicPage()) return null;
    var props = event.properties || {};
    ['$current_url', '$initial_current_url', '$session_entry_url', '$session_exit_url'].forEach(function (key) {
      if (props[key]) props[key] = cleanURL(props[key]);
    });
    ['$referrer', '$initial_referrer', '$session_entry_referrer'].forEach(function (key) {
      if (props[key]) { var domain = referringDomain(props[key]); props[key] = domain === '$direct' ? '$direct' : 'https://' + domain + '/'; }
    });
    props.t305_environment = environment;
    props.t305_locale = page.locale;
    props.t305_integration = 'shopify-theme-v2';
    event.properties = props;
    return event;
  }
  function bridgeData() {
    if (!sdk || !active || !permitted()) return null;
    return {v:2, distinct_id:sdk.get_distinct_id(), session_id:sdk.get_session_id(),
      environment:environment, identified:Boolean(page.customer), attribution:attribution(), updated_at:Date.now()};
  }
  function writeBridgeCookie(data) {
    document.cookie = cookieKey + '=' + encodeURIComponent(JSON.stringify(data)) + '; Path=/; Max-Age=1800; SameSite=Lax; Secure';
  }
  function syncBridge(force) {
    var data = bridgeData();
    if (!data) return Promise.resolve(false);
    writeBridgeCookie(data);
    var value = JSON.stringify(data);
    var stable = JSON.stringify(Object.assign({}, data, {updated_at:0}));
    if (!force && stable === bridgeValue) return Promise.resolve(true);
    if (bridgePromise) return bridgePromise;
    bridgePromise = originalFetch(root + 'cart.js', {credentials:'same-origin'})
      .then(function (r) { if (!r.ok) throw new Error('cart-read'); return r.json(); })
      .then(function (cart) {
        reconcileBuilder(cart);
        if (!cart.item_count || !permitted()) return false;
        var attributes = {}; attributes[bridgeKey] = value;
        return originalFetch(root + 'cart/update.js', {method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes:attributes}), keepalive:true})
          .then(function (r) { if (!r.ok) throw new Error('cart-link'); bridgeValue = stable;
            document.documentElement.setAttribute('data-t305-posthog-cart-link', 'synced'); return true; });
      }).catch(function () { document.documentElement.setAttribute('data-t305-posthog-cart-link', 'cookie-fallback'); return false; })
      .finally(function () { bridgePromise = null; });
    return bridgePromise;
  }
  function clearBridge() {
    try { sessionStorage.removeItem(builderKey); } catch (_) {}
    document.cookie = cookieKey + '=; Path=/; Max-Age=0; SameSite=Lax; Secure';
    bridgeValue = '';
    var attributes = {}; attributes[bridgeKey] = '';
    originalFetch(root + 'cart/update.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:attributes}),keepalive:true}).catch(function () {});
  }
  function capture(name, properties) { if (sdk && active && permitted()) sdk.capture(name, properties || {}); }
  function reconcileBuilder(cart) {
    if (!Array.isArray(cart.items) || !permitted()) return;
    var pending;
    try { pending = JSON.parse(sessionStorage.getItem(builderKey) || 'null'); sessionStorage.removeItem(builderKey); } catch (_) {}
    if (pending && Array.isArray(pending.items) && Date.now() - pending.started_at < 86400000) {
      var before = {}, after = {}, details = {};
      pending.items.forEach(function (item) { before[item.variant_id] = (before[item.variant_id] || 0) + item.quantity; });
      cart.items.forEach(function (item) { after[item.variant_id] = (after[item.variant_id] || 0) + item.quantity; details[item.variant_id] = item; });
      Object.keys(after).forEach(function (id) {
        var quantity = after[id] - (before[id] || 0), item = details[id];
        if (quantity > 0) capture('product_added_to_cart', {product_id:String(item.product_id),variant_id:String(id),
          product_title:item.product_title,product_handle:item.handle,quantity:quantity,cart_line_quantity:after[id],
          price:Number(item.final_price === undefined ? item.price : item.final_price) / 100,currency:page.currency,
          source:'kixxl_return_cart_increase',transport:'cart_reconciliation'});
      });
    }
    cartSnapshot = cart.items.map(function (item) { return {variant_id:String(item.variant_id),quantity:item.quantity}; });
  }
  function start() {
    if (!permitted() || !publicPage()) {
      if (active && sdk) { sdk.stopSessionRecording(); sdk.opt_out_capturing(); clearBridge(); }
      active = false; status('consent-blocked'); return;
    }
    if (!sdk) { load(); return; }
    if (!active) {
      active = true; sdk.opt_in_capturing();
      if (page.customer) sdk.identify('shopify_customer_' + page.customer.id, {email:page.customer.email,shopify_customer_id:String(page.customer.id)});
      else if (String(sdk.get_distinct_id()).indexOf('shopify_customer_') === 0) sdk.reset();
      sdk.register({t305_environment:environment,t305_locale:page.locale,t305_integration:'shopify-theme-v2'});
      sdk.register_for_session(attribution());
      sdk.startSessionRecording();
    }
    if (!pageSent) {
      pageSent = true; startedAt = Date.now();
      capture('$pageview', Object.assign({$current_url:cleanURL(window.location.href)}, campaign()));
      if (page.product) capture('product_viewed', page.product);
    }
    syncBridge(false); status('capturing-' + environment);
  }
  function initialize() {
    if (initializing || !permitted() || !publicPage()) return;
    if (!window.posthog || typeof window.posthog.init !== 'function') { status('sdk-unavailable'); return; }
    initializing = true;
    window.posthog.init(token, {
      api_host:'https://us.i.posthog.com', ui_host:'https://us.posthog.com', defaults:'2026-05-30',
      persistence:'localStorage+cookie', persistence_name:'t305_' + environment, cross_subdomain_cookie:false,
      person_profiles:'identified_only', opt_out_capturing_by_default:true,
      autocapture:true, capture_pageview:false, capture_pageleave:false, rageclick:true, capture_dead_clicks:true,
      enable_heatmaps:true, capture_exceptions:true, capture_performance:{web_vitals:true,network_timing:false},
      disable_session_recording:false, enable_recording_console_log:true, disable_surveys:true,
      mask_all_element_attributes:true, save_campaign_params:true, save_referrer:true, ip:true,
      session_recording:{maskAllInputs:true, recordCanvas:false, recordHeaders:false, recordBody:false,
        blockSelector:'iframe, canvas, input[type="file"], .ph-no-capture, [data-private]',
        maskTextSelector:'.ph-mask, [data-private]',
        maskNetworkRequestFn:function (request) { request.url = cleanURL(request.url); return request; }},
      before_send:beforeSend,
      loaded:function (instance) { sdk = instance; window.t305PostHog = instance; start(); }
    }, 't305Storefront');
  }
  function load() {
    if (initializing || loading) return;
    if (window.posthog && typeof window.posthog.init === 'function') { initialize(); return; }
    if (window.posthog) { status('incompatible-sdk'); return; }
    loading = true; status('loading-sdk');
    var script = document.createElement('script');
    script.async = true; script.crossOrigin = 'anonymous'; script.referrerPolicy = 'no-referrer';
    script.src = 'https://us-assets.i.posthog.com/static/array.js';
    script.onload = function () { loading = false; initialize(); };
    script.onerror = function () { loading = false; status('sdk-load-failed'); };
    document.head.appendChild(script);
  }
  function cartAddURL(value) {
    try { var u = new URL(value, window.location.origin); return u.origin === window.location.origin && /\/cart\/add(?:\.js)?$/.test(u.pathname); }
    catch (_) { return false; }
  }
  function added(data, transport) {
    if (!active || !permitted()) return;
    var items = Array.isArray(data.items) ? data.items : [data];
    items.forEach(function (item) {
      if (!item || !item.variant_id || !item.product_id) return;
      capture('product_added_to_cart', {product_id:String(item.product_id),variant_id:String(item.variant_id),
        product_title:item.product_title,product_handle:item.handle,cart_line_quantity:item.quantity,
        price:Number(item.final_price === undefined ? item.price : item.final_price) / 100,
        currency:page.currency,transport:transport,page_product_handle:page.product && page.product.product_handle,
        source:'successful_cart_add_response'});
    });
    syncBridge(true);
  }
  window.fetch = function (input, init) {
    var result = originalFetch(input, init);
    var url = typeof input === 'string' ? input : input && input.url;
    if (cartAddURL(url)) result.then(function (r) { if (r.ok && active) r.clone().json().then(function (data) { added(data,'fetch'); }).catch(function () {}); }).catch(function () {});
    return result;
  };
  var xhrOpen = XMLHttpRequest.prototype.open, xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) { this.__t305CartAdd = cartAddURL(url); return xhrOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__t305CartAdd) { var xhr = this; xhr.addEventListener('loadend',function () {
      if (xhr.status >= 200 && xhr.status < 300 && active) {
        try { added(xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText),'xhr'); } catch (_) {}
      }
    }, {once:true}); }
    return xhrSend.apply(this, arguments);
  };
  function beforeCheckout(resume) {
    if (blockedCheckout || !active || !permitted()) return false;
    blockedCheckout = true;
    Promise.race([syncBridge(true),new Promise(function (resolve) { setTimeout(resolve,1500); })])
      .finally(function () { resume(); blockedCheckout = false; });
    return true;
  }
  document.addEventListener('submit',function (event) {
    var form = event.target, submitter = event.submitter;
    if (!form || !submitter || submitter.name !== 'checkout' || blockedCheckout) return;
    if (beforeCheckout(function () { form.requestSubmit(submitter); })) event.preventDefault();
  },true);
  document.addEventListener('click',function (event) {
    if (!event.target.closest) return;
    if (event.target.closest('#submit-link.gangify-submit-button') && active && permitted() && cartSnapshot) {
      try { sessionStorage.setItem(builderKey,JSON.stringify({started_at:Date.now(),items:cartSnapshot})); } catch (_) {}
    }
    var link = event.target.closest('a[href]');
    if (!link) return;
    try {
      var u = new URL(link.href,window.location.origin);
      if (u.origin !== window.location.origin) return;
      var route = u.pathname.replace(/^\/(?:es\/)?products\//,'').replace(/\/$/,'');
      if (routes.indexOf(route) >= 0) capture('t305_order_route_selected',{order_route:route});
      if (/^\/(?:es\/)?checkout\/?$/.test(u.pathname) && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
        if (beforeCheckout(function () { window.location.assign(link.href); })) event.preventDefault();
      }
    } catch (_) {}
  },true);
  window.addEventListener('pagehide',function () {
    if (pageSent && !leaveSent && active && permitted()) { leaveSent = true; capture('$pageleave',{$pageview_duration:Math.round((Date.now()-startedAt)/1000)}); }
  });
  window.addEventListener('pageshow',function (event) { if (event.persisted) { leaveSent=false; startedAt=Date.now(); syncBridge(true); } });
  document.addEventListener('visitorConsentCollected',start);
  status('waiting-for-consent-api');
  if (window.Shopify.customerPrivacy) start();
  else if (typeof window.Shopify.loadFeatures === 'function') window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function (error) { if (error) status('consent-api-unavailable'); else start(); });
  else status('consent-api-unavailable');
}());
